module.exports = __webpack_public_path__ + "static/media/wati-logo-1.e1693a65.svg";